import { BaseModel } from "../../service/models/base";

export interface Permission {
  module: string;
  action: string[];
}
export interface Role extends BaseModel {
  old_id: any;
  title: string;
  desc: string;
  active: boolean;
  org?: string;
  permissions: Permission[];
}

export interface EmpDocModel extends BaseModel {
  id?: any;
  uid: any;
  category: string;
  type: string;
  file_type: string;
  url: string;
  status: string;
}

export interface CustomerAttachmentModel {
  id?: string;
  url: string;
  type: string;
  created_at?: Date;
  created_by?: string;
  created_by_name?: string;
  category?: string;
  deleted?: boolean;
}

export interface CustomerContactDetailModel {
  // mobile: string;
  email: string;
  website?: string;
  name_of_contact_person: string;
  designation_of_contact_person: string;
  mobile_no_of_contact_person: string;
  email_id_of_contact_person: string;
  name_of_accounts_spoc?: string;
  designation_of_accounts_spoc?: string;
  mobile_no_of_accounts_spoc?: string;
  email_id_of_accounts_spoc?: string;
}

export interface RegisteredofficeAddressModel {
  line1?: string;
  line2?: string;
  line3?: string;
  city?: string;
  state?: string;
  country?: string;
  pincode?: number;
}

export const GSTRegisteredStatus = {
  register_regular: "Registered (Regular)",
  regesiter_composition: "Registered (Composition)",
  unregistered: "Unregistered",
};

export interface GSTDetailModel {
  gst_registration?: string;
  gst_number?: string;
  attachments?: CustomerAttachmentModel[];
}

export const CustomerType = {
  sole_proprietorship: "Sole Proprietorship",
  partnership_firm: "Partnership Firm",
  LLP: "Limited Liability Partnership (LLP)",
  Lvt_Ltd: "Private Limited Company(Pvt Ltd)",
  Public_Ltd: "Public Limited Company",
  HUF: "HUF",
};

export const LeadSegment = {
  OEM: "OEM",
  retail_chain: "Retail Chain",
  distributor: "Distributor",
  dealer: "Dealer",
  battery_swapping: "Battery Swapping",
  "E-rickshaw": "E-Rickshaw",
  RWA: "RWA",
  Fleet: "Fleet",
  CPO: "CPO",
  Enterprise: "Enterprise",
  inside_sales: "Inside Sales",
  Operations: "Operations",
  "Online or E-commerce": "Online or E-Commerce",
  "Park & Charge": "Park & Charge",
  Others: "Others",
};

export interface CustomerAddionalDetailsModel {
  customer_type?: string;
  customer_group?: string;
  lead_segment?: string;
  brand?: string;
  store_name?: string;
  pan_no?: string;
  aadhaar_no?: string;
  sales_person?: string;
  rm_uid?: string;
  sales_person_uid?: string;
  relationship_manager?: string;
  dealer_code?: string;
}

export const customer_status = {
  pending: "Pending for Approval", //when created PR
  approved: "Approved",
  // onHold: "On Hold",
  rejected: "Rejected",
  updated: "Update Pending", //even though updated status id on Pending.
  // save_draft: "Save draft"
};

export const AddressType = {
  billing: "Billing",
  delivery: "Delivery",
  other: "Other",
};

export interface CustomerBillingAddressModel {
  branch_name?: string;
  type: string;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  country: string;
  pincode: number;
}

// A customer can have multiple SPOCs (contact persons); each SPOC owns one or
// more delivery addresses. Order creation picks one SPOC, then a delivery
// address from that SPOC.
export interface CustomerSpocModel {
  id: string;
  email?: string;
  website?: string;
  name_of_contact_person: string;
  designation_of_contact_person?: string;
  mobile_no_of_contact_person: string;
  email_id_of_contact_person?: string;
  name_of_accounts_spoc?: string;
  designation_of_accounts_spoc?: string;
  mobile_no_of_accounts_spoc?: string;
  email_id_of_accounts_spoc?: string;
  delivery_addresses: CustomerBillingAddressModel[];
}

export interface UserModel {
  _id?: any;
  id?: string;
  created_by?: any;
  updated_by?: any;
  created_at?: Date;
  updated_at?: Date;
  created_by_name?: string;
  updated_by_name?: string;
  deleted?: boolean;
  deleted_at?: Date;
  deleted_by?: any;
  deleted_by_name?: string;
  uid?: any;
  first_name: string;
  last_name: string;
  password?: string;
  profile_image?: string;
  customer_contact_details?: CustomerContactDetailModel;
  registered_office_address?: RegisteredofficeAddressModel;
  gst_details?: GSTDetailModel;
  gst?: string;
  additional_customer_details?: CustomerAddionalDetailsModel;
  billing_address?: CustomerBillingAddressModel[];
  delivery_address?: CustomerBillingAddressModel[];
  spocs?: CustomerSpocModel[];
  attachments?: CustomerAttachmentModel[];
  mobile?: string;
  status?: string;
  reject_reason?: string;
  email: string;
  email_verified: boolean;
  mobile_verified: boolean;
  active: boolean;
  dob?: string | Date;
  isEmp?: boolean;
  emp_profile?: EmpProfileModel;
  token?: string;
}

export const defaultCustomer: UserModel = {
  first_name: "",
  last_name: "",
  email: "",
  email_verified: false,
  mobile_verified: false,
  active: true,
  status: customer_status.pending,
  billing_address: [],
  delivery_address: [],
};

export interface EmpProfileModel extends BaseModel {
  emp_id?: string;
  designation?: string;
  department?: string;
  sub_dep?: string;
  doj?: string | Date;
  dol?: string | Date;
  pp_month?: number;
  permanent_address?: string;
  address?: string;
  reporting_to_name?: string;
  reporting_to_id?: number;
  hod_id?: number;
  hod_name?: string;
  zone: string;
  isHod: boolean;
  isReportingManager: boolean;
  weekoff:
    | { off: number[]; alt_off: number[]; alt_off_even_week: boolean }
    | string;
  linked_in?: string;
  roles?: string[];
  permissions?: Role[];
  active: boolean;
  docs?: EmpDocModel[];
  blood_group?: string;
  emergency_contact?: string;
  emp_type?: string;
  date_of_earned_leave_start?: string | Date | null;
  education?: string;
  education_degree_name?: string;
}

export const defaultEmpValue: UserModel = {
  first_name: "",
  last_name: "",
  mobile: "",
  email: "",
  email_verified: false,
  mobile_verified: false,
  active: true,
  created_by: 0,
  updated_by: 0,
  emp_profile: {
    emp_id: "",
    roles: [],
    active: true,
    department: "",
    sub_dep: "",
    zone: "",
    doj: "",
    dol: "",
    isHod: false,
    isReportingManager: false,
    weekoff: {
      off: [],
      alt_off: [],
      alt_off_even_week: false,
    },
    permanent_address: "",
    blood_group: "",
    emergency_contact: "",
    education: "",
    education_degree_name: "",
    emp_type: "",
  },
};
